module.exports = __webpack_public_path__ + "static/media/zen-three.5b595aaf.svg";